import * as React from "react";
import { markdown, ReactSpecimen } from "catalog";
import { Header, Navigation, MainTitle } from "./Header";
const sampleTagItems = [
    { label: "Lorem ipsum", "@id": "foo", "@type": "Dimension" },
    {
        label: "dolor sit amet consectetur",
        "@id": "foo2",
        "@type": "Dimension"
    },
    { label: "adipisicing", "@id": "foo3", "@type": "Topic" },
    { label: "Eum ipsam cupiditate", "@id": "foo4", "@type": "Dimension" },
    { label: "quibusdam commodi", "@id": "foo5", "@type": "Topic" },
    { label: "ducimus esse sint", "@id": "foo6", "@type": "Dimension" },
    { label: "error accusantium", "@id": "foo8", "@type": "Time" },
    { label: "labore reprehenderit", "@id": "foo7", "@type": "Location" }
];
const mockPrimaryLinks = [
    { url: "/", label: "Startseite" },
    { url: "/kontakt", label: "Kontakt" }
];
const mockSecondaryLinks = [
    { url: "/impressum", label: "Impressum" },
    { url: "/datenschutz", label: "Datenschutz" }
];
export default () => markdown `

## Header

${(<ReactSpecimen responsive>
    <Header suggestedTags={[]} selectedTags={[]} addSearchTag={() => { }} removeSearchTag={() => { }}/>
  </ReactSpecimen>)}


With suggestions

${(<ReactSpecimen responsive>
    <Header suggestedTags={sampleTagItems} selectedTags={[]} addSearchTag={() => { }} removeSearchTag={() => { }}/>
  </ReactSpecimen>)}

## Home

${(<ReactSpecimen responsive>
    <Header home suggestedTags={sampleTagItems} selectedTags={[]} addSearchTag={() => { }} removeSearchTag={() => { }}/>
  </ReactSpecimen>)}

## Main Title

${(<ReactSpecimen dark>
    <MainTitle>Statistisches Informationsportal</MainTitle>
  </ReactSpecimen>)}

## Navigation Menu

${(<ReactSpecimen dark responsive>
    <Navigation primaryItems={mockPrimaryLinks} secondaryItems={mockSecondaryLinks} id="ex-1"/>
  </ReactSpecimen>)}

${(<ReactSpecimen dark responsive>
    <Navigation expanded primaryItems={mockPrimaryLinks} secondaryItems={mockSecondaryLinks} id="ex-2"/>
  </ReactSpecimen>)}

`;



// WEBPACK FOOTER //
// ./src/components/Header.docs.tsx